// extracted by mini-css-extract-plugin
export default {"container":"BonusGroup_container__8MJl5","title":"BonusGroup_title__ihzej","balance":"BonusGroup_balance__GWCzP","logo":"BonusGroup_logo__D8o2W"};